export interface AppState {
  testTrigger: boolean | null;
}

export enum AppActionEnum {
  APP_TEST = "APP_TEST",
}

const initialState: AppState = {
  testTrigger: null,
};

const appReducer = (
  state: AppState = initialState,
  action: { type: AppActionEnum; value: string },
): AppState => {
  switch (action.type) {
    case AppActionEnum.APP_TEST:
      return {
        ...state,
        testTrigger: state.testTrigger === null ? true : !state.testTrigger,
      };
    default:
      return state;
  }
};

export default appReducer;

export const appTestTrigger = () => ({
  type: AppActionEnum.APP_TEST,
});
